import React from 'react';
import styled, { keyframes } from 'styled-components';

// Animation keyframes
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
`;

const Container = styled.div`
  background: #292d2e;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #25ee89, transparent);
    opacity: 0.5;
  }
`;

const FooterWrapper = styled.div`
  color: #ffffff;
  
  display: flex;
  justify-content: space-between;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  position: relative;
  z-index: 2;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const GlowingDivider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #25ee89, transparent);
  margin: 20px 0;
  opacity: 0.3;
`;

// First section with 45% width
const Section = styled.div`
  ${props => props.isFirst ? 'flex: 0 0 45%;' : 'flex: 1;'}
  padding: 0px;
  color: #fff;
  
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  animation: ${fadeInUp} 0.8s ease-out;
  animation-delay: ${props => props.delay || '0s'};
  animation-fill-mode: both;

  @media (max-width: 768px) {
  text-align: -webkit-center;
    flex: 1;
    padding: 0;
    
  }
`;

const Logo = styled.img`
  width: 180px;
  height: auto;
  filter: brightness(0.9);
  transition: all 0.3s ease;
  
  &:hover {
    filter: brightness(1.1);
    transform: scale(1.02);
  }
`;

const Description = styled.div`
  font-size: 13px;
  line-height: 1.6;
  margin-top: 20px;
  color: #cccccc;
  
  strong {
    color: #25ee89;
    font-weight: 600;
  }
`;

const LinkHeader = styled.h3`
  color: #25ee89;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 90px;
    height: 2px;
    background: #25ee89;
    border-radius: 1px;
    opacity: 0.7;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

const LinkWrapper = styled.div`
 @media (max-width: 768px) {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  
 }
`;

const Link = styled.a`
  color: #cccccc;
  text-decoration: none;
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 15px;
  
  &::before {
    content: '▶';
    position: absolute;
    left: 0;
    color: #25ee89;
    font-size: 10px;
    transition: all 0.3s ease;
    opacity: 0;
    transform: translateX(-5px);
  }
  
  &:hover {
    color: #25ee89;
    transform: translateX(5px);
    
    &::before {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

const IconContainer = styled.div`
 
  gap: 12px;
  flex-wrap: wrap;
  margin-left: 5px;
 
  
  @media (max-width: 495px) {
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
`;

const CurrencyContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-left: 5px;
    @media (max-width: 495px) {
   
    justify-content: center;
    gap: 8px;
  }
`;

const SocialLinksRow = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: row;
    gap: 15px;
  }
`;

const SocialLinksColumn = styled.div`
  display: flex;
  
  gap: 8px;
  flex: 1;
  min-width: 0;
  flex-direction: column;

  @media (min-width: 769px) {
    
    gap: 12px;
  }
`;

const SocialLinksHorizontal = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-left: 5px;
`;

const CurrencyIcon = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  transition: all 0.3s ease;
  filter: brightness(0.8);
  
  &:hover {
    transform: translateY(-2px) scale(1.05);
    filter: brightness(1.1);
  }
`;

const SocialIcon = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 8px;
  transition: all 0.3s ease;
  padding: 6px;
  background: rgba(255, 255, 255, 0.05);
  filter: brightness(0.8);
  
  &:hover {
    background: rgba(240, 156, 6, 0.1);
    transform: translateY(-2px);
    filter: brightness(1.1);
  }
`;

const SocialLinkItem = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width:11rem
  color: #cccccc;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
  padding: 4px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.02);
  
  &:hover {
    background: rgba(240, 156, 6, 0.1);
    color: #25ee89;
    transform: translateX(5px);
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
  }
`;

const SocialLinkText = styled.span`
  font-size: 13px;
  font-weight: 500;
  
  @media (max-width: 768px) {
    display: inline;
  }
  
  @media (min-width: 769px) {
    display: none;
  }
`;

const SocialLinkTextDesktop = styled.span`
  font-size: 13px;
  font-weight: 500;
  
  @media (max-width: 768px) {
    display: none;
  }
  
  @media (min-width: 769px) {
    display: inline;
  }
`;

const FooterContainerTop = styled.div`
  padding: 60px 40px;
  margin-left: ${props => props.isCollapsed ? '160px' : '250px'};
  transition: margin-left 0.3s ease;

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 30px 20px;
  }
`;

const AwardContainer = styled.div`
  display: flex;

  gap: 20px;
  
  background: #292d2e;
  overflow-x: auto;
  position: relative;
  border: 1px solid #292d2e;
  border-radius: 8px;
  
  &::-webkit-scrollbar {
    height: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #292d2e;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #25ee89;
    border-radius: 3px;
    opacity: 0.7;
  }
`;

const AwardCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #292d2e;
  border-radius: 12px;
  padding: 20px 16px;
  min-width: 160px;
  transition: all 0.3s ease;
  border: 1px solid #292d2e;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-5px);
    border-color: #25ee89;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  }
`;

const AwardImage = styled.div`
  width: 120px;
  height: 80px;
  margin-bottom: 15px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: brightness(0.9);
  }
`;

const AwardTitle = styled.h3`
  color: #25ee89;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  margin-left:3px;
  // text-transform: uppercase;
  letter-spacing: 0.5px;
  &:hover {
    
    color: #fff;
    
  }
`;

const AwardSubtitle = styled.p`
  color: #cccccc;
  font-size: 12px;
  text-align: center;
  margin: 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const AwardYear = styled.span`
  color: #25ee89;
  font-size: 12px;
  font-weight: 600;
`;

const LogoContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: 10px 0;
  background: #292d2e;
  border-radius: 8px;
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
  justify-content: center;
  min-width: max-content;
`;

const Logo1 = styled.div`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  display: flex;
  align-items: center;
  animation: ${float} 6s ease-in-out infinite;
  animation-delay: ${props => props.index * 0.5}s;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: brightness(0.6) grayscale(0.8);
    transition: all 0.4s ease;
    
    &:hover {
      filter: brightness(0.9) grayscale(0.3);
      transform: scale(1.05);
    }
  }
`;

const NoteSection = styled.div`
  background: #292d2e;
  color: #aaaaaa;
  padding: 30px;
  text-align: center;
  font-size: 13px;
  margin-top: 20px;
  border-top: 1px solid #292d2e;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 1px;
    background: linear-gradient(90deg, transparent, #25ee89, transparent);
    opacity: 0.5;
  }
`;

const NoteText = styled.p`
  margin: 0;
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
  
  strong {
    color: #25ee89;
  }
`;

const EmailHighlight = styled.span`
  color: #25ee89;
  font-weight: 600;
`;

const awards = [
  {
    title: 'Best on Mobile',
    organization: 'Sigma Africa',
    year: '2024',
    image: '/assets/images/bcgames/awards/a1.webp'
  },
  {
    title: 'Best Casino Operator',
    organization: 'Sigma Europe',
    year: '2023',
    image: '/assets/images/bcgames/awards/a2.webp'
  },
  {
    title: 'Crypto Game Platform',
    organization: 'Sigma Asia',
    year: '2023',
    image: '/assets/images/bcgames/awards/a1.webp'
  },
  {
    title: 'Crypto Casino',
    organization: 'Sigma Europe',
    year: '2022',
    image: '/assets/images/bcgames/awards/a3.webp'
  },
  {
    title: 'Crypto Casino',
    organization: 'Sigma Africa',
    year: '2022',
    image: '/assets/images/bcgames/awards/a4.webp'
  },
  {
    title: 'Blockchain Gaming',
    organization: 'Platform America',
    year: '2022',
    image: '/assets/images/bcgames/awards/a5.webp'
  },
  {
    title: 'Crypto Casino',
    organization: 'Affpapa',
    year: '2022',
    image: '/assets/images/bcgames/awards/a6.webp'
  },
  {
    title: 'Crypto Casino',
    organization: 'Sigma Europe',
    year: '2022',
    image: '/assets/images/bcgames/awards/a7.webp'
  }
];

const logos = [
  { id: 1, src: '/assets/images/bcgames/promote/p1.webp', alt: 'Sigma', width: 100, height: 40 },
  { id: 2, src: '/assets/images/bcgames/promote/p2.webp', alt: 'Responsible Gambling', width: 100, height: 60 },
  { id: 3, src: '/assets/images/bcgames/promote/p3.webp', alt: 'GamCare', width: 100, height: 90 },
  { id: 4, src: '/assets/images/bcgames/promote/p4.webp', alt: 'Betblocker', width: 150, height: 50 },
  { id: 5, src: '/assets/images/bcgames/promote/p5.webp', alt: '18+', width: 50, height: 50 },
  { id: 6, src: '/assets/images/bcgames/promote/p6.webp', alt: 'Cloud9', width: 130, height: 45 },
  // { id: 7, src: '/assets/images/bcgames/promote/p7.png', alt: 'Circular Logo', width: 50, height: 50 },
];

const socialLinks = [
  { src: "/assets/images/svg/x.svg", alt: "X.com", href: "https://x.com/bkk07.bet_", name: "bkk07.com X" },
  { src: "/assets/images/svg/x.svg", alt: "X.com", href: "https://x.com/bkk07.bet_bns", name: "bkk07.com BNS" },
  { src: "/assets/images/svg/x.svg", alt: "X.com", href: "https://x.com/bkk07.bet_sp", name: "bkk07.com SP" },
  { src: "/assets/images/svg/x.svg", alt: "X.com", href: "https://x.com/bkk07.bet_g", name: "bkk07.com Gaming" },
  { src: "/assets/images/svg/facebook.svg", alt: "Facebook", href: "https://www.facebook.com/share/16p8Fq3wXw/?mibextid=wwXIfr", name: "Facebook" },
  { src: "/assets/images/svg/insta.svg", alt: "Instagram", href: "http://instagram.com/bitcoin_jito", name: "Instagram" },
  { src: "/assets/images/svg/discord.svg", alt: "Discord", href: "https://discord.gg/JC3DT753Rm", name: "Discord" },
  { src: "/assets/images/svg/telegram.svg", alt: "bkk07.com.com", href: "https://t.me/bkk07.com", name: "bkk07.com.com" },
  { src: "/assets/images/svg/telegram.svg", alt: "bkk07.com sports", href: "https://t.me/bkk07.betsports", name: "bkk07.com Sports" },
  { src: "/assets/images/svg/telegram.svg", alt: "bkk07.com announcement", href: "https://t.me/bkk07.betAnnouncement", name: "Announcements" },
  { src: "/assets/images/svg/telegram.svg", alt: "bkk07.com Giveaway", href: "https://t.me/bkk07.betGiveaway", name: "Giveaways" },
];

const HelloFooter = () => {
  const isCollapsed = false; // Mock value for demo
  
  return (
    <Container>
      <FooterContainerTop isCollapsed={isCollapsed}>
        {/* Awards Section */}
        {/* <AwardContainer>
          {awards.map((award, index) => (
            <AwardCard key={index}>
              <AwardImage>
                <img src={award.image} alt={award.title} />
              </AwardImage>
              <AwardTitle>{award.title}</AwardTitle>
              <AwardSubtitle>{award.organization}</AwardSubtitle>
              <AwardYear>{award.year}</AwardYear>
            </AwardCard>
          ))}
        </AwardContainer> */}

        {/* Partner Logos */}
        <GlowingDivider />
        <LogoContainer>
          <LogoWrapper>
            {logos.map((logo, index) => (
              <Logo1 key={logo.id} width={logo.width} height={logo.height} index={index}>
                <img src={logo.src} alt={logo.alt} />
              </Logo1>
            ))}
          </LogoWrapper>
        </LogoContainer>

        <GlowingDivider />

        {/* Main Footer Content */}
     <FooterWrapper>
  <Section delay="0.2s" isFirst={true}>
    <Logo src="/assets/images/lg.png" alt="bkk07.com" />
    <Description>
      <strong>bkk07.com</strong> The Most Trusted and Award-Winning Gaming Platform.
      <br/>
      Step into next-level online gaming with bkk07.com, where innovation meets excitement! Explore thousands of games, including E-sports, Live Casino, Slots, Crash, HashDice, Plinko, and more. Bet on live sports, enjoy instant withdrawals, and claim unbeatable bonuses – all in one place.
      <br/>
      Join thousands of players who trust bkk07.com for a secure, fair, and thrilling gaming experience – whether you play with crypto or fiat currency.
      <br/>
      By using bkk07.com, you confirm that you've read and agree to our <a href='/provably-fair'><strong>Terms of Service</strong></a> and <a href='/provably-fair'><strong>Responsible Gaming Policy</strong></a>.
      <br/>
      <strong>Please note:</strong> Cryptocurrency trading is not classified as gambling and therefore falls outside the scope of our gaming license
    </Description>
  </Section>

  <Section delay="0.6s">
    <LinkHeader>Quick Links</LinkHeader>
    <LinkWrapper>
    <Link href="/provably-fair">Help Center</Link>
    <Link href="/provably-fair">User Agreement</Link>
    <Link href="/provably-fair">Privacy Policy</Link>
    <Link href="/provably-fair">Responsible Gaming</Link>
    </LinkWrapper>
    <LinkHeader>Contact Us</LinkHeader>
    <Link href="mailto:admin@bkk07.com.com">
      Email: <EmailHighlight>admin@bkk07.com.com</EmailHighlight>
    </Link>
    </Section>
   

  <Section delay="0.8s">
    <LinkHeader style={{marginBottom:"20px"}}>Accepted Currencies</LinkHeader>
    <CurrencyContainer>
      <CurrencyIcon src="/assets/images/btc.png" alt="Bitcoin" />
      <CurrencyIcon src="/assets/images/eth.png" alt="Ethereum" />
      <CurrencyIcon src="/assets/images/doge.png" alt="Dogecoin" />
      <CurrencyIcon src="/assets/images/TETHER.png" alt="Tether" />
      <CurrencyIcon src="/assets/images/ltc.png" alt="Litecoin" />
    </CurrencyContainer>
    <LinkHeader style={{marginTop: '25px'}}>Follow Us</LinkHeader>
    
    <SocialLinksRow>
      <SocialLinksColumn>
        <AwardTitle>X links</AwardTitle>
        <IconContainer>
          {socialLinks.slice(0, 4).map((social, index) => (
            <SocialLinkItem key={index} href={social.href} target="_blank" rel="noopener noreferrer">
              <SocialIcon src={social.src} alt={social.alt} />
              <SocialLinkText>{social.name}</SocialLinkText>
              <SocialLinkTextDesktop>{social.name}</SocialLinkTextDesktop>
            </SocialLinkItem>
          ))}
        </IconContainer>
      </SocialLinksColumn>
      
      <SocialLinksColumn>
        <AwardTitle>Telegram links</AwardTitle>
        <IconContainer>
          {socialLinks.slice(8, 12).map((social, index) => (
            <SocialLinkItem key={index} href={social.href} target="_blank" rel="noopener noreferrer">
              <SocialIcon src={social.src} alt={social.alt} />
              <SocialLinkText>{social.name}</SocialLinkText>
              <SocialLinkTextDesktop>{social.name}</SocialLinkTextDesktop>
            </SocialLinkItem>
          ))}
        </IconContainer>
      </SocialLinksColumn>
    </SocialLinksRow>
   
    {/* <AwardTitle>Social links</AwardTitle>
    <SocialLinksHorizontal>
      {socialLinks.slice(4, 7).map((social, index) => (
        <a key={index} href={social.href} target="_blank" rel="noopener noreferrer">
          <SocialIcon src={social.src} alt={social.alt} />
        </a>
      ))}
    </SocialLinksHorizontal> */}
  </Section>
</FooterWrapper>

        <NoteSection>
          <NoteText>
            This website offers gaming with risk experience. To be a user of our site you must be <strong>over 18 years old</strong>. 
            We are not responsible for the violation of your local laws related to i-gaming. 
            <strong> Play responsibly and have fun on bkk07.com.</strong>
          </NoteText>
        </NoteSection>
      </FooterContainerTop>
    </Container>
  );
};

export default HelloFooter;